import axios from "axios";

import { Admin } from "../components/AdminUsersDialog";
import { ManualItem } from "../types";


const employeePortalRequest = axios.create({
    baseURL: process.env.REACT_APP_MANUALS_API,
	headers: {
		'x-api-key': process.env.REACT_APP_MANUALS_API_KEY,
	}
})

export const getManualRequest = async (employeeCode: string) => {
	const headers = {
		'user-token': '1234',
		'employee-code': employeeCode,
	}
	const result = await employeePortalRequest.get("manuals", {headers})
		.then(r => r)
		.catch(e => e.response);
	return result
}

export const getManualById = async (employeeCode: string, manualId: string) => {
	const headers = {
		'user-token': '1234',
		'employee-code': employeeCode,
	}
	const result = await employeePortalRequest.get("manuals", {headers})
		.then(r => {
			return r.data?.Items?.find((m: any) => m.manualId === manualId)
		})
		.catch(e => e.response);
	return result
}


export const getUserIsAdmin = async (employeeCode: string) => {
	
	const headers = {
		'user-token': '1234',
		'employee-code': employeeCode,
	}
	const result = await employeePortalRequest.get("admins/user-is-admin", {headers})
		.then(r => r.data)
		.catch(e => e.response);
	return result
}

export const getAmins = async (employeeCode: string) => {
	const headers = {
		'user-token': '1234',
		'employee-code': employeeCode,
	}
	const result = await employeePortalRequest.get("admins", {headers})
		.then(r => r.data)
		.catch(e => e.response);
	return result
}

export const saveAmin = async (employeeCode: string, data: Admin) => {
	const headers = {
		'user-token': '1234',
		'employee-code': employeeCode,
	}
	const result = await employeePortalRequest.post("admins", data, {headers})
		.then(r => r.data)
		.catch(e => e.response);
	return result
}

export const modifyAmin = async (employeeCode: string, data: Admin) => {
	const headers = {
		'user-token': '1234',
		'employee-code': employeeCode,
	}
	const result = await employeePortalRequest.put("admins", data, {headers})
		.then(r => r.data)
		.catch(e => e.response);
	return result
}

export const setManualRequest = async (manualData: ManualItem) => {
	const result = await employeePortalRequest.post( 
		"manuals",
		manualData,
		// {headers: {"user-token": userToken}},
	)
		.then(r => r)
		.catch(e => e.response);
	return result
}


export const modifyManualRequest = async (manualData: ManualItem
) => {
	const result = await employeePortalRequest.put( 
		"manuals",
		manualData,
		// {headers: {"user-token": userToken}},
	)
		.then(r => r)
		.catch(e => e.response);
	return result
}


export const signedUploadUrl = async (employeeCode: string, data: any): Promise<any> => {
    // const authCompanySelectedState = store.getState().auth.companyselected;
	// const headers = {
	// 	token: authCompanySelectedState?.Token,
	// 	ModuleId: process.env.REACT_APP_MODULE_ID,
	// 	AccessType: 1,
	// }
	const headers = {
		'user-token': '1234',
		'employee-code': employeeCode,
	}
	const result = await employeePortalRequest.post( 
			"presigned-url/upload",
			data,
			{headers}
		).then(r => r.data)
		.catch(e => {
			console.error(e);
			return null;
		});
	return result
}


export const getAvailableS10Users = async () => {
	const response = await axios.post(
	  'https://s10cloud.com:5033/api/SecurityAuthApi/GetSecurityUserForHelpDesk',
	  {
		TokenCorporation: 'EAAAAKTJRbOrTzgHVqiDKrcr5PW7ywmhi8XDY/NAui6Lc9Hq'
	  }
	).then(r => r)
	.catch(e => {
		console.error(e);
		return null;
	});
	return response;
}
